import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import "firebase/compat/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDvf7JnGjM3ZiDQKjqRcdpH-hbz0tSvDSs",
  authDomain: "streamline-7e36a.firebaseapp.com",
  projectId: "streamline-7e36a",
  storageBucket: "streamline-7e36a.appspot.com",
  messagingSenderId: "933518900990",
  appId: "1:933518900990:web:17720bceec981d44f2efaf",
};

// init firebase
firebase.initializeApp(firebaseConfig);

// init services
const projectFirestore = firebase.firestore();
const projectAuth = firebase.auth();
const projectStorage = firebase.storage();

// timestamp
const timestamp = firebase.firestore.Timestamp;

export { projectAuth, projectFirestore, projectStorage, timestamp };
